'use client';

import { useTranslations } from 'next-intl';
import {
  Conditional,
  HeaderStoreLocationButton,
  useBreakpoint
} from 'components/pcc-components';
import { useStoreInfoDrawer } from '../../store-info-drawer-context';
import { useAssociatedDealer } from 'components/associated-dealers/associated-dealer-context';
import { useDealerLocatorDrawer } from 'components/dealer-locator/dealer-locator-drawer-context';
import usePathContains from 'hooks/use-path-contains';
import { PAGE_BREAKPOINTS } from 'app/[lang]/[esite]/(core)/equipment/[partName]/[partNumber]/constants/constants';

interface StoreLocationButtonProps {
  isLoggedIn: boolean;
  isDealerUser: boolean;
  isStoreLocationOptimizationFlag: boolean;
}

export const StoreLocationButton = ({
  isLoggedIn,
  isDealerUser,
  isStoreLocationOptimizationFlag
}: StoreLocationButtonProps) => {
  const t = useTranslations();
  const storeInfoDrawer = useStoreInfoDrawer();
  const { associatedDealerDrawer } = useAssociatedDealer();
  const dealerLocatorDrawer = useDealerLocatorDrawer();
  const { checkPathHas } = usePathContains();
  const { checkPathExactHas } = usePathContains();

  const changeLocationLabel = t('MA_DROPDOWN_IA_CHANGE_STORE');
  const handleClick = () => {
    storeInfoDrawer.closeDrawer();
    isLoggedIn
      ? associatedDealerDrawer.openDrawer()
      : dealerLocatorDrawer.openDrawer();
  };
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  return (
    <Conditional
      test={
        isDealerUser ||
        (!checkPathExactHas('cart') && !checkPathHas('/confirmation'))
      }
      fallback={null}
    >
      <HeaderStoreLocationButton
        label={changeLocationLabel}
        onClick={handleClick}
        isStoreLocationOptimizationFlag={isStoreLocationOptimizationFlag}
        isMobile={!isMD}
      />
    </Conditional>
  );
};
